export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID предложения"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID мейкера"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Введите ID код"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Введите ID мейкера"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Показать мои предложения"])}
}